var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contents.length>0)?_c('div',{staticClass:"card kultour-story mt30 mb30"},[_c('span',{staticClass:"title"},[_vm._v("Geschichten aus den Kulturspuren")]),_vm._l((_vm.contents),function(content){return _c('story-part',{staticClass:"part",attrs:{"content":content}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }